import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../reducer";

export const selectComponents = (state: RootState) => state.ui.components;

export const makeSelectComponent = (componentId: string | undefined) =>
  createSelector(selectComponents, (components) => {
    if (!componentId) return undefined;
    if (!(componentId in components)) return undefined;
    return components[componentId];
  });

export const selectServiceAccounts = (state: RootState) =>
  state.ui.serviceAccounts;

export const makeSelectServiceAccount = (
  serviceAccountId: string | undefined,
) =>
  createSelector(selectServiceAccounts, (serviceAccounts) => {
    if (!serviceAccountId) return undefined;
    if (!(serviceAccountId in serviceAccounts)) return undefined;
    return serviceAccounts[serviceAccountId];
  });

export const selectDevcontainers = (state: RootState) => state.ui.devcontainers;
export const makeSelectDevcontainer = (id: string | undefined) =>
  createSelector(selectDevcontainers, (m) => (!id || !(id in m) ? undefined : m[id]));

export const selectVolumes = (state: RootState) => state.ui.volumes;
export const makeSelectVolume = (id: string | undefined) =>
  createSelector(selectVolumes, (m) => (!id || !(id in m) ? undefined : m[id]));
